import AbstractRequestTask from "../../AbstractRequestTask";
import getAppConfig from "../../../../config/appConfig";
import {ENABLE_MODAL_RETRIES} from '../../../RequestManagerConstants';

class userTask extends AbstractRequestTask {
  constructor(params) {
    super();
    this.gamificationId = params.gamificationId;
  }

  getHeaders() {
    return {};
  }

  getParams() {
    return { }
  }

  getUrl() {
    const url = 'https://www.clarovideo.com';
    return `${url}/api/social/user/${this.gamificationId}`;
  }

  success(data, b) {
      return this.resolve(data);
  }

  isValid (data){
      return data && data.status == true || false;
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
  
}

export default userTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/social/user/userTask.js